// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.priceDetailsContainer[data-v-07404875] {
  grid-template-rows: 0fr;
  padding: 0;
  transition:
    grid-template-rows 0.3s ease,
    padding 0.3s ease;
}
.priceDetailsContainer.open[data-v-07404875] {
    grid-template-rows: 1fr;
    padding-top: 8px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
